import { useEffect } from 'react'

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

// A modal dialog's focus (scheduled-org member experience, T7 review carry):
// while open, focus starts on `initialRef` and Tab / Shift+Tab cycle inside
// `dialogRef`; on close, focus returns to whatever had it when the dialog
// opened (the row that opened the sheet), if it is still on the page. The
// opener is read here, before the initial focus moves (so no autoFocus).
export const useDialogFocus = (open, dialogRef, initialRef) => {
  useEffect(() => {
    if (!open) return undefined
    const opener = document.activeElement
    const first = initialRef && initialRef.current
    if (first) first.focus()

    const onKey = e => {
      const dialog = dialogRef.current
      if (e.key !== 'Tab' || !dialog) return
      const items = Array.from(dialog.querySelectorAll(FOCUSABLE))
      if (!items.length) { e.preventDefault(); return }
      const active = document.activeElement
      const inside = dialog.contains(active)
      const head = items[0]
      const tail = items[items.length - 1]
      if (e.shiftKey && (!inside || active === head)) {
        e.preventDefault()
        tail.focus()
      } else if (!e.shiftKey && (!inside || active === tail)) {
        e.preventDefault()
        head.focus()
      }
    }
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('keydown', onKey)
      if (opener && opener !== document.body && typeof opener.focus === 'function' && document.contains(opener)) opener.focus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])
}
